module.exports = __webpack_public_path__ + "static/img/6.0e34f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/2/6.png
// module id = JctT
// module chunks = 0